export default "__VITE_ASSET__DMntBiCR__"